export const setTab = (tab: string) => {
  return {
    type: 'SETTAB',
    payload: tab,
  }
}
